import React, { Fragment, useContext, useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import MasterLayout from "../masterLayout/MasterLayout";
import * as Lu from "react-icons/lu";
import Masonry from "react-layout-masonry";
import { toast } from "react-toastify";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";

function AlterReservationSettings() {
  const navigate = useNavigate();
  const { createNewReservations, tokenData, fetchCurrentSettings } =
    useContext(AppContext);
  const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  const [slots, setSlots] = useState(
    days.reduce((acc, day) => {
      acc[day] = [{ start: "", end: "" }];
      return acc;
    }, {})
  );
  const [exception, setException] = useState([
    { startDate: "", endDate: "", comments: "" },
  ]);

  const [otherSettings, setOtherSettings] = useState({
    early_booking: "",
    late_booking: "",
    late_cancel: "",
    time_interval: "",
    max_party_size: 1,
  });
  const [isSynced, setIsSynced] = useState(false);

  const addSlot = (day) => {
    setSlots((prevSlots) => {
      if (isSynced) {
        return days.reduce((newSlots, d) => {
          newSlots[d] = [...prevSlots[d], { start: "", end: "" }];
          return newSlots;
        }, {});
      }

      return {
        ...prevSlots,
        [day]: [...prevSlots[day], { start: "", end: "" }],
      };
    });
  };

  const addException = () => {
    setException((prev) => [
      ...prev,
      { startDate: "", endDate: "", comments: "" },
    ]);
  };

  const handleExceptionChange = (index, field, value) => {
    setException((prev) =>
      prev.map((exception, i) => {
        if (i === index) {
          if (field === "startDate" && value) {
            const startDate = new Date(value);

            const endDate = new Date(startDate);
            endDate.setHours(startDate.getHours() + 12);

            return {
              ...exception,
              startDate: value,
              endDate: endDate.toISOString().slice(0, 16),
            };
          }

          // Otherwise, just update the changed field
          return { ...exception, [field]: value };
        }

        return exception;
      })
    );
  };

  // const handleInputChange = (day, index, field, value) => {
  //   setSlots((prevSlots) => {
  //     const updatedSlots = [...prevSlots[day]];
  //     updatedSlots[index][field] = value;
  //     return { ...prevSlots, [day]: updatedSlots };
  //   });
  // };

  const onOtherSettingsChange = (e) => {
    const { name, value } = e.target;

    console.log(name, value);
    setOtherSettings((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputChange = (day, index, key, value) => {
    if (key === "start" || key === "end") {
      const updatedSlot = { ...slots[day][index], [key]: value };
      console.log(updatedSlot.start, updatedSlot.end);

      if (updatedSlot.start && updatedSlot.end) {
        const startTime = new Date(`1970-01-01T${updatedSlot.start}:00`);
        let endTime = new Date(`1970-01-01T${updatedSlot.end}:00`);

        // if (endTime <= startTime) {
        //   endTime = new Date(endTime.getTime() + 24 * 60 * 60 * 1000);
        // }

        if (endTime <= startTime) {
          toast.error("End time must be greater than start time.");
          return;
        }
      }
    }
    if (isSynced) {
      setSlots((prevSlots) => {
        const updatedSlot = { ...prevSlots[day][index], [key]: value };
        return days.reduce((newSlots, d) => {
          newSlots[d] = prevSlots[d].map((slot, i) =>
            i === index ? updatedSlot : slot
          );
          return newSlots;
        }, {});
      });
    } else {
      setSlots((prevSlots) => ({
        ...prevSlots,
        [day]: prevSlots[day].map((slot, i) =>
          i === index ? { ...slot, [key]: value } : slot
        ),
      }));
    }
  };

  // const deleteSlot = (day, index) => {
  //   setSlots((prevSlots) => {
  //     if (prevSlots[day].length > 1) {
  //       const updatedSlots = prevSlots[day].filter((_, i) => i !== index);
  //       return { ...prevSlots, [day]: updatedSlots };
  //     }
  //     return prevSlots;
  //   });
  // };

  const deleteSlot = (day, index) => {
    if (isSynced) {
      setSlots((prevSlots) =>
        days.reduce((newSlots, d) => {
          newSlots[d] = prevSlots[d].filter((_, i) => i !== index);
          return newSlots;
        }, {})
      );
    } else {
      setSlots((prevSlots) => ({
        ...prevSlots,
        [day]: prevSlots[day].filter((_, i) => i !== index),
      }));
    }
  };

  const resetSlot = (day, index) => {
    const resetValue = { start: "", end: "" };
    if (isSynced) {
      setSlots((prevSlots) =>
        days.reduce((newSlots, d) => {
          newSlots[d] = prevSlots[d].map((slot, i) =>
            i === index ? resetValue : slot
          );
          return newSlots;
        }, {})
      );
    } else {
      setSlots((prevSlots) => ({
        ...prevSlots,
        [day]: prevSlots[day].map((slot, i) =>
          i === index ? resetValue : slot
        ),
      }));
    }
  };

  const removeEmptySlots = (slots) => {
    const cleanedSlots = Object.keys(slots).reduce((newSlots, day) => {
      const filteredDaySlots = slots[day].filter(
        (slot) => slot.start !== "" || slot.end !== ""
      );

      if (filteredDaySlots.length === 0) {
        newSlots[day] = null;
      } else {
        newSlots[day] = filteredDaySlots;
      }

      return newSlots;
    }, {});
    return cleanedSlots;
  };

  const removeException = (index) => {
    setException((prev) => prev.filter((_, i) => i !== index));
  };

  const validateOtherSettings = () => {
    const missingFields = [];

    Object.keys(otherSettings).forEach((key) => {
      if (
        otherSettings[key] === "" ||
        otherSettings[key] === null ||
        otherSettings[key] === undefined
      ) {
        missingFields.push(key.replace(/_/g, " "));
      }
    });

    return missingFields.length > 0
      ? `The following fields are required: ${missingFields.join(", ")}`
      : null;
  };

  const handleSettings = async (e) => {
    e.preventDefault();

    if (!tokenData) {
      toast.error("Token data unavailable!");
      return;
    }

    const validatedSlots = removeEmptySlots(slots);

    const isValidOtherSettings = validateOtherSettings();

    console.log(isValidOtherSettings);
    if (isValidOtherSettings != null) {
      toast.error(isValidOtherSettings);
      return;
    }

    const stringifiedSlots = Object.keys(validatedSlots).reduce(
      (newSlots, day) => {
        const value = validatedSlots[day];

        newSlots[day] = value === null ? null : JSON.stringify(value);
        return newSlots;
      },
      {}
    );

    const payload = {
      shopName: tokenData?.shopUrl,
      shopId: tokenData?.id,
      exceptions: null,
      ...stringifiedSlots,
      ...otherSettings,
    };

    await createNewReservations(payload, {
      onSuccess: async (res) => {
        toast.success("New settings created");
        navigate("/reservation-settings");
        await fetchCurrentSettings();
      },
      onFailed: (err) => {
        let errMsg = err?.message ?? "Settings cretion error";
        toast.error(errMsg);
      },
    });
  };

  const today = new Date().toISOString().slice(0, 16);

  return (
    <Fragment>
      <MasterLayout>
        <Breadcrumb
          pageTitle="Create Reservation Settings"
          title="Create Settings"
        />
        <form action="" onSubmit={handleSettings}>
          <div className="position-relative h-100 p-3 radius-12">
            <p className="sub_title">Schedules</p>
            <div className="row">
              <div className="col-10"></div>
              <div className="col-lg-2 col-sm-2 col-md-2">
                <div className="form-switch switch-primary d-flex align-items-center justify-content-center">
                  <label htmlFor="" className="form-label pt-4 pe-4 me-10">
                    Reflect All
                  </label>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    onChange={() => setIsSynced(!isSynced)}
                  />
                </div>
              </div>
            </div>
            <div>
              <Masonry
                columns={{ 640: 1, 768: 2, 991: 3, 1024: 3, 1280: 3 }}
                gap={16}
              >
                {days &&
                  days.map((day, index) => {
                    return (
                      <div className="m-2" key={index}>
                        <div className="card reserv_settings_card p-3">
                          <button
                            type="button"
                            className="add_slot_btn"
                            onClick={() => addSlot(day)}
                          >
                            + Add
                          </button>
                          <p htmlFor="" className="days_label text-capitalize">
                            {day}
                          </p>

                          {slots &&
                            slots[day].map((slot, index) => {
                              return (
                                <div className="row" key={index}>
                                  <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="form-group">
                                      <label htmlFor="" className="form-label">
                                        Start
                                      </label>
                                      <input
                                        type="time"
                                        name=""
                                        id=""
                                        className="form-control"
                                        value={slot.start}
                                        style={{
                                          fontSize: "13px",
                                          fontWeight: "600",
                                        }}
                                        onChange={(e) =>
                                          handleInputChange(
                                            day,
                                            index,
                                            "start",
                                            e.target.value
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-6 col-sm-6 col-md-6">
                                    <div className="form-group">
                                      <label htmlFor="" className="form-label">
                                        End
                                      </label>
                                      <input
                                        type="time"
                                        name=""
                                        id=""
                                        className="form-control"
                                        value={slot.end}
                                        onChange={(e) =>
                                          handleInputChange(
                                            day,
                                            index,
                                            "end",
                                            e.target.value
                                          )
                                        }
                                        style={{
                                          fontSize: "13px",
                                          fontWeight: "600",
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="btn_grp_new">
                                    {slots[day] && slots[day].length > 1 && (
                                      <button
                                        type="button"
                                        className="trash_slot"
                                        onClick={() => deleteSlot(day, index)}
                                      >
                                        <Lu.LuTrash2 />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      className="reset_btn"
                                      onClick={() => resetSlot(day, index)}
                                    >
                                      reset
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    );
                  })}
              </Masonry>
            </div>
          </div>
          <div className=" h-100 p-3 mt-3 radius-12">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12">
                {/* <div className="card p-3">
                  <p className="sub_title">Exceptions</p>
                  <p className="subtitle_2">
                    {" "}
                    * Define special opening hours for holidays, events or other
                    needs. Leave the time empty if you're closed all day.
                  </p>
                  <div className="form-group position-relative">
                    {exception &&
                      exception.map((excep, index) => {
                        return (
                          <div className="mt-3">
                            <button
                              type="button"
                              className="add_slot_btn"
                              onClick={() => addException()}
                            >
                              + Add
                            </button>
                            <div className="row">
                              <p>
                                <strong>{`#${index + 1}`}</strong>
                              </p>
                              <div className="col-lg-6 col-md-6 col-sm-6">
                                <label htmlFor="" className="form-label">
                                  Start Date
                                </label>
                                <input
                                  type="datetime-local"
                                  name=""
                                  id=""
                                  className="form-control"
                                  onChange={(e) =>
                                    handleExceptionChange(
                                      index,
                                      "startDate",
                                      e.target.value
                                    )
                                  }
                                  value={excep.startDate}
                                  min={today}
                                />
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-6">
                                <label htmlFor="" className="form-label">
                                  End Date
                                </label>
                                <input
                                  type="datetime-local"
                                  name=""
                                  id=""
                                  className="form-control"
                                  onChange={(e) =>
                                    handleExceptionChange(
                                      index,
                                      "endDate",
                                      e.target.value
                                    )
                                  }
                                  value={excep.endDate}
                                  min={today}
                                />
                              </div>
                            </div>
                            <div className="form-group mt-3">
                              <label htmlFor="" className="form-label">
                                Comments
                              </label>
                              <textarea
                                name=""
                                id=""
                                cols="30"
                                className="form-control"
                                onChange={(e) =>
                                  handleExceptionChange(
                                    index,
                                    "comments",
                                    e.target.value
                                  )
                                }
                                value={exception.comments}
                              ></textarea>
                            </div>
                            {exception && exception.length > 1 && (
                              <button
                                type="button"
                                className="trash_slot"
                                onClick={() => removeException(index)}
                              >
                                <Lu.LuTrash2 />
                              </button>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div> */}
                <div className="card p-3 mt-3">
                  <p className="sub_title">Early Bookings</p>
                  <p className="subtitle_2">
                    {" "}
                    * Select how early customers can make their booking.
                    (Administrators and Booking Managers are not restricted by
                    this setting.)
                  </p>
                  <div className="form-group position-relative">
                    <select
                      name="early_booking"
                      id=""
                      className="form-select"
                      onChange={onOtherSettingsChange}
                    >
                      <option value="" selected disabled>
                        Choose an option
                      </option>
                      <option value="any_time">Any Time</option>
                      <option value="1">From 1 day in advance</option>
                      <option value="7">From 7 day in advance</option>
                      <option value="14">From 14 day in advance</option>
                      <option value="30">From 30 day in advance</option>
                      <option value="60">From 60 day in advance</option>
                      <option value="90">From 90 day in advance</option>
                    </select>
                  </div>
                </div>
                <div className="card mt-3 p-3">
                  <p className="sub_title">Late Bookings</p>
                  <p className="subtitle_2">
                    {" "}
                    * Select how late customers can make their booking.
                    (Administrators and Booking Managers are not restricted by
                    this setting.)
                  </p>
                  <div className="form-group position-relative">
                    <select
                      name="late_booking"
                      id=""
                      className="form-select"
                      onChange={onOtherSettingsChange}
                    >
                      <option value="" selected disabled>
                        Choose an option
                      </option>
                      <option value="1">Up to last minute</option>
                      <option value="15">From 15 minutes in advance</option>
                      <option value="30">From 30 minutes in advance</option>
                      <option value="45">From 45 minutes in advance</option>
                      <option value="60">From 1 hour in advance</option>
                      <option value="240">From 4 hours in advance</option>
                      <option value="1440">From 24 hours in advance</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                {/* <div className="card p-3">
                  <p className="sub_title">Early Bookings</p>
                  <p className="subtitle_2">
                    {" "}
                    * Select how early customers can make their booking.
                    (Administrators and Booking Managers are not restricted by
                    this setting.)
                  </p>
                  <div className="form-group position-relative">
                    <select name="" id="" className="form-select">
                      <option value="" selected disabled>
                        Choose an option
                      </option>
                      <option value="any_time">Any Time</option>
                      <option value="1">From 1 day in advance</option>
                      <option value="7">From 7 day in advance</option>
                      <option value="14">From 14 day in advance</option>
                      <option value="30">From 30 day in advance</option>
                      <option value="60">From 60 day in advance</option>
                      <option value="90">From 90 day in advance</option>
                    </select>
                  </div>
                </div> */}

                <div className="card mt-3 p-3">
                  <p className="sub_title">Late Cancel</p>
                  <p className="subtitle_2">
                    {" "}
                    * Select how late customers can cancel their booking.
                    (Administrators and Booking Managers are not restricted by
                    this setting.)
                  </p>
                  <div className="form-group position-relative">
                    <select
                      name="late_cancel"
                      id=""
                      className="form-select"
                      onChange={onOtherSettingsChange}
                    >
                      <option value="" selected disabled>
                        Choose an option
                      </option>
                      <option value="1">Up to last minute</option>
                      <option value="30">From 30 minutes in advance</option>
                      <option value="60">From 1 hour in advance</option>
                      <option value="240">From 4 hours in advance</option>
                      <option value="1440">From 24 hours in advance</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="card mt-3 p-3">
                      <p className="sub_title">Time Interval</p>
                      <p className="subtitle_2">
                        {" "}
                        * Select the number of minutes between each available
                        time.
                      </p>
                      <div className="form-group position-relative">
                        <select
                          name="time_interval"
                          id=""
                          className="form-select"
                          onChange={onOtherSettingsChange}
                        >
                          <option value="" selected disabled>
                            Choose an option
                          </option>
                          <option value="180">Every 180 minutes</option>
                          <option value="160">Every 160 minutes</option>
                          <option value="120">Every 120 minutes</option>
                          <option value="90">Every 90 minutes</option>
                          <option value="60">Every 60 minutes</option>
                          <option value="30">Every 30 minutes</option>
                          <option value="15">Every 15 minutes</option>
                          <option value="10">Every 10 minutes</option>
                          <option value="5">Every 5 minutes</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="card mt-3 p-3">
                      <label htmlFor="" className="form-label">
                        Party Size
                      </label>
                      <p className="subtitle_2">
                        {" "}
                        * Size of the party (Chairs limit).
                      </p>
                      <input
                        type="number"
                        name="max_party_size"
                        id=""
                        className="form-control mt-3"
                        min={1}
                        onChange={onOtherSettingsChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="submit" className="submit_btn mt-20">
              Submit
            </button>
          </div>
        </form>
      </MasterLayout>
    </Fragment>
  );
}

export default AlterReservationSettings;
